/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Sortbyrarity3Inputs */

const id_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutkan berdasarkan Kelangkaan`)
};

const ms_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun mengikut Kecelaruan`)
};

const da_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter efter Sjældenhed`)
};

const de_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Seltenheit sortieren`)
};

const en_us2_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by Rarity`)
};

const es_es2_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por rareza`)
};

const es_mx2_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por rareza`)
};

const fil_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbukud-bukurin ayon sa Rarity`)
};

const fr_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier par rareté`)
};

const it_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina per rarità`)
};

const hu_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendezés ritkaság szerint`)
};

const nl_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteren op zeldzaamheid`)
};

const no_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter etter sjeldenhet`)
};

const pl_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortuj według rzadkości`)
};

const pt_br2_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificar por raridade`)
};

const pt_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por raridade`)
};

const ro_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortează după raritate`)
};

const fi_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järjestä harvinaisuuden mukaan`)
};

const sv_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortera efter sällsynthet`)
};

const vi_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp theo độ hiếm`)
};

const tr_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadirliğe Göre Sırala`)
};

const cs_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seřadit podle vzácnosti`)
};

const bg_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортиране по рядкост`)
};

const ru_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировка по редкости`)
};

const uk_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортувати за рідкістю`)
};

const ar_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتيب حسب الندرة`)
};

const hi_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दुर्लभता के अनुसार क्रमबद्ध करें`)
};

const th_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียงตามความหายาก`)
};

const ja_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レアリティ順`)
};

const zh_cn2_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按稀有度排序`)
};

const zh_hant1_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按稀有度排序`)
};

const ko_offerdetail_achievements_sortbyrarity3 = /** @type {(inputs: Offerdetail_Achievements_Sortbyrarity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`희귀도별 정렬`)
};

/**
* | output |
* | --- |
* | "Sort by Rarity" |
*
* @param {Offerdetail_Achievements_Sortbyrarity3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_sortbyrarity3 = /** @type {((inputs?: Offerdetail_Achievements_Sortbyrarity3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Sortbyrarity3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "da") return da_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "de") return de_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "it") return it_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "no") return no_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "th") return th_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_sortbyrarity3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_sortbyrarity3(inputs)
	return ko_offerdetail_achievements_sortbyrarity3(inputs)
});
export { offerdetail_achievements_sortbyrarity3 as "offerDetail.achievements.sortByRarity" }